export const ASSET_REPORT_LABEL = {
  ASSET: '자산',
  LIABILITY: '부채',
  NET_ASSET: '순자산',
  HUSBAND: '남편',
  WIFE: '아내',
  SAVINGS: '저축',
  INVESTMENT: '투자',
  EXPECT_TO_CONSUME: '지출예정',
  ETC: '기타',
  LOAN: '대출',
};
